import React from 'react';
import {Button} from '@mui/material';
import {t} from '../../themes/statamicTokens';

const variants = {
    primary: {
        backgroundColor: t.color.accent.primary,
        color: t.color.accent.onPrimary,
        border: `1px solid ${t.color.accent.primary}`,
        '&:hover': {
            backgroundColor: t.color.accent.primaryHover,
            borderColor: t.color.accent.primaryHover,
        },
    },
    secondary: {
        backgroundColor: t.color.surface,
        color: t.color.text.primary,
        border: `1px solid ${t.color.border.default}`,
        '&:hover': {
            backgroundColor: t.color.sidebarHover,
            borderColor: t.color.border.strong,
        },
    },
    ghost: {
        backgroundColor: 'transparent',
        color: t.color.text.secondary,
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: t.color.sidebarHover,
            color: t.color.text.primary,
        },
    },
    danger: {
        backgroundColor: t.color.surface,
        color: t.color.status.dangerSolid,
        border: `1px solid ${t.color.border.default}`,
        '&:hover': {
            backgroundColor: t.color.status.dangerTint,
            borderColor: t.color.status.dangerSolid,
        },
    },
};

const PrimaryButton = ({variant = 'primary', sx, ...props}) => (
    <Button
        disableElevation
        disableRipple
        variant="text"
        sx={{
            textTransform: 'none',
            fontSize: `${t.type.body.size}px`,
            fontWeight: 500,
            lineHeight: 1.2,
            borderRadius: `${t.radius.sm}px`,
            px: 2,
            py: 1,
            minHeight: 36,
            boxShadow: 'none',
            ...variants[variant],
            ...sx,
        }}
        {...props}
    />
);

export default PrimaryButton;
